import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { Skeleton } from '@mui/material';

export function TasksForEntitySkeleton() {
    return <StatDisplay name="Active Tasks" value={<Skeleton variant="text" width={80} />} />;
}
